module.exports = __webpack_public_path__ + "static/media/markerFilter1.c94edbef.svg";